import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { TextNotFoundElementDataType } from '@/components/sections/builder/elements/body/not-found/type';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { TextIcon } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: TextNotFoundElementDataType = {
  name: 'Text',
  text: '404',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as TextNotFoundElementDataType;

  return (
    <p
      className='block w-full text-base text-[--text-color] duration-100'
      data-animation='true'
      dangerouslySetInnerHTML={{ __html: data.text }}
    />
  );
};

export const ElementSetting = ({ element }: ElementProps) => {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );
  const data = element.data as TextNotFoundElementDataType;

  return (
    <div>
      <h1 className='mb-4 text-sm font-bold'>Text Settings</h1>
      <div className='my-4'>
        <label className='mb-2 block'>Text</label>
        <TextEditorMinimal
          value={data.text}
          onChange={(text) =>
            builder.setChildData(element.parentId as string, element.id, { text })
          }
          output='html'
          className='mb-2 w-full max-w-64'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
    </div>
  );
};

const TextNotFound = {
  type: 'not_found_text',
  group: 'not_found',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: TextIcon,
  Icon: TextIcon,
  childs: [],
};

export default TextNotFound;
